import { render, staticRenderFns } from "./ActivateUser.vue?vue&type=template&id=72977c4d&scoped=true&"
import script from "./ActivateUser.vue?vue&type=script&lang=ts&"
export * from "./ActivateUser.vue?vue&type=script&lang=ts&"
import style0 from "./ActivateUser.vue?vue&type=style&index=0&id=72977c4d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72977c4d",
  null
  
)

export default component.exports